import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCode"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9.96967 8.46967L11.0303 9.53033L8.56066 12L11.0303 14.4697L9.96967 15.5303L6.43934 12L9.96967 8.46967ZM12.9697 9.53033L15.4393 12L12.9697 14.4697L14.0303 15.5303L17.5607 12L14.0303 8.46967L12.9697 9.53033Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCode;
